import { ErrorMessage, Form, Formik } from "formik";
import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { passwordValidationSchema } from "../../validationSchema/ValidationSchema";
import Button from "../../components/Button";
import Lable from "../../components/Lable";
import PasswordInput from "../../components/PasswordInput";
import { useSelector } from "react-redux";
import LoaderContext from "../../components/loader";
import AuthApi from "../../apis/auth.apis";
import { toast } from "react-toastify";
import { IoMdClose } from "react-icons/io";
import { FormField } from "../../components/FormField";
import TextInput from "../../components/TextInput";

const ChangePassword = ({ onClose }) => {
  const { handleLoading } = useContext(LoaderContext);
  const { loading } = useSelector((state) => state.store);

  const navigate = useNavigate();
  const location = useLocation();
  const { emailOrPhone } = location.state || {};

  useEffect(() => {
    handleLoading(loading);
  }, [handleLoading, loading]);

  const initialValues = {
    emailOrPhone: emailOrPhone || "",
    password: "",
    confirmPassword: "",
  };

  const handleSubmit = async (values) => {
    console.log("values", values);
    handleLoading(true);
    const payload = {
      emailOrPhone: values.emailOrPhone,
      newPassword: values?.password,
    };
    console.log("payload", payload);
    try {
      const res = await AuthApi?.resetPassword(payload);
      console.log("res", res);
      toast.success("Password reset successfully");
      navigate("/");
      handleLoading(false);
    } catch (error) {
      console.log("error", error);
      handleLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
      <div className="bg-white border border-red-500 p-4 rounded-lg shadow-lg w-full max-w-xl">
        <div className="flex justify-between border-b pb-2 text-gray-900 text-lg font-semibold">
          <span>Reset Password</span>
          <span>
            <IoMdClose onClick={onClose} />
          </span>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={passwordValidationSchema}
          onSubmit={handleSubmit}
        >
          {({ handleChange, values }) => (
            <Form className="mt-4">
              <div className="gap-3  grid grid-cols-1 sm:grid-cols-2 items-center mb-3">
                <Lable lable="Email" />
                <FormField>
                  <TextInput
                    name="emailOrPhone"
                    type="email"
                    placeholder="Email"
                    onChange={handleChange}
                    value={values.emailOrPhone}
                  />
                  <ErrorMessage
                    name="emailOrPhone"
                    component="div"
                    className="error"
                  />
                </FormField>

                <Lable lable="New Password" />
                <div>
                  <PasswordInput
                    name="password"
                    type="password"
                    placeholder="New Password"
                    onChange={handleChange}
                    value={values.password}
                    autoComplete
                  />
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="error"
                  />
                </div>
              </div>

              <div className="gap-3  grid grid-cols-1 sm:grid-cols-2 items-center mb-3">
                <Lable lable="Confirm Password" />
                <div>
                  <PasswordInput
                    name="confirmPassword"
                    type="confirmPassword"
                    placeholder="Confirm Password"
                    onChange={handleChange}
                    value={values.confirmPassword}
                    autoComplete
                  />
                  <ErrorMessage
                    name="confirmPassword"
                    component="div"
                    className="error"
                  />
                </div>
              </div>

              <div className="mt-8 flex gap-4 justify-center flex-wrap">
                <Button text={"Cancel"} onClick={onClose} />
                <Button text={"Update Password"} type={"submit"} />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ChangePassword;
